// core
import React, { useEffect } from 'react';

// library
import { gsap } from 'gsap'


export const BannerImage = () => {
    const animaBars = (id, tranPoint, fromV, toV, per) => {
        gsap.fromTo(id, 1.5, {scaleY: fromV, svgOrigin: tranPoint}, {
            scaleY: toV,
            ease: 'sine.inOut',
            stagger: {each: per, repeat: -1, yoyo: true},
            delay: -3
        });
    };


    const blockAnimation = () => {

        let idSVG = `#group5-animation `;

        gsap.from(idSVG + '#wave', 1.5, {x: -53.67, ease: 'none', repeat: -1});
        gsap.to(idSVG + '#arrow-left', 1, {x: 10, ease: 'sine.inOut', repeat: -1, yoyo: true});
        gsap.to(idSVG + '#arrow-up', 1, {y: 10, ease: 'sine.inOut', repeat: -1, yoyo: true});

        animaBars(idSVG + '#bars-1 > *', '258px 207.43px', 0.5, 1.1, 0.2);
        gsap.to(idSVG + '#diagram', 1, {
            rotate: 360,
            ease: 'sine.inOut',
            svgOrigin: '367.87px 120.96px',
            repeat: -1,
            repeatDelay: 1
        });

        animaBars(idSVG + '#chart-shape > *', '236px 356.07px', 0.9, 1, 0.75);
        animaBars(idSVG + '#bars-3 > *', '562px 210px', 0.7, 1, 0.6);
        animaBars(idSVG + '#bars-4 > *', '543px 400px', 0.7, 1, 0.5);

        gsap.to(idSVG + '#diagram-2', 1, {
            scale: 1.2,
            ease: 'sine.inOut',
            svgOrigin: '446.5px 389px',
            repeat: -1,
            repeatDelay: 1,
            yoyo: true
        });

        gsap.to(idSVG + '#splash-1 > path', 0.5, {
            strokeDashoffset: 13,
            ease: 'sine.inOut',
            repeat: -1,
            repeatDelay: 1.5
        });
        gsap.to(idSVG + '#splash-2 > path', 0.5, {
            strokeDashoffset: 18,
            ease: 'sine.inOut',
            repeat: -1,
            repeatDelay: 1.5,
            delay: 0.5
        });

        gsap.to([idSVG + '#bl-2', idSVG + '#bl-3', idSVG + '#bg-texture', idSVG + '#bg-bl'], 1.5, {
            y: -10,
            ease: 'sine.inOut',
            stagger: {each: 0.5, repeat: -1, yoyo: true},
            delay: -4
        });

    };

    useEffect(() => {
        blockAnimation();
    }, []);

    return (
        <svg id="group5-animation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 648 481">
            <defs>
                <clipPath id="clip-wave">
                    <rect x="71.24" y="434.46" width="81.52" height="46.54" />
                    <rect x="177.24" y="434.46" width="108.69" height="46.06" />
                </clipPath>
            </defs>
            <g id="bg-texture">
                <path d="M293,72.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M311,72.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M329,72.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M346,72.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M363,72.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M380,72.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M399,72.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M417,72.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M293,91.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M311,91.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M329,91.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M346,91.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M363,91.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M380,91.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M399,91.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M417,91.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M293,109.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M311,109.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M329,109.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M346,109.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M363,109.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M380,109.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M399,109.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M417,109.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M293,127.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M311,127.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M329,127.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M346,127.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M363,127.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M380,127.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M399,127.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M417,127.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M293,145.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M311,145.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M329,145.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M346,145.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M363,145.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M380,145.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M399,145.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M417,145.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M293,163.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M311,163.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M329,163.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M346,163.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M363,163.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M380,163.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M399,163.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
                <path d="M417,163.5a4.5,4.5,0,1,1-4.5-4.5,4.49,4.49,0,0,1,4.5,4.5" fill="#e2e8ef"
                      fillRule="evenodd" />
            </g>
            <path id="bg-bl" d="M293,414H533V254H293Z" fill="#b6c3d7" fillRule="evenodd" />
            <path id="arrow-left"
                  d="M191.16,293.32H39.36V272.5L4.5,308.08l34.86,35.57V322.83h151.8V293.32"
                  fill="#f6f7f9" fillRule="evenodd" />
            <path id="mes" d="M181,151V311.2h81.32L301,356l-7.79-44.8H421V151H181" fill="#f6f7f9"
                  fillRule="evenodd" />
            <path d="M288,278H554v-7H288Zm0-9H554v-4H288Zm0-7H554v-3H288Zm0-6H554v-2H288Z"
                  fill="#fffffe" fillRule="evenodd" />
            <path id="arrow-up"
                  d="M169.27,187.15V34.94H190L154.56,0,119.08,34.94h20.77V187.15h29.42"
                  fill="#e4e8eb" fillRule="evenodd" />
            <g>
                <path d="M77.19,153.49H231.94V82.73H77.19Z" fill="#d8dde2" fillRule="evenodd" />
                <path
                    d="M17.05,153.63h298.1v-6.69H17.05Zm0-10.22h298.1v-4.09H17.05Zm0-7.44h298.1v-3H17.05Zm0-7.44h298.1v-1.84H17.05Z"
                    fill="#fffffe" fillRule="evenodd" />
            </g>
            <g clipPath="url(#clip-wave)">
                <g id="wave">
                    <path
                        d="M500.61,437.75c-13.42,0-13.42,42-26.84,42s-13.42-42-26.84-42-13.42,42-26.84,42-13.41-42-26.83-42-13.42,42-26.84,42-13.41-42-26.83-42-13.42,42-26.83,42-13.42-42-26.83-42-13.42,42-26.84,42-13.42-42-26.84-42-13.42,42-26.84,42-13.42-42-26.83-42-13.42,42-26.84,42-13.42-42-26.83-42-13.42,42-26.84,42-13.41-42-26.83-42"
                        fill="none" stroke="#192331" strokeMiterlimit="10" strokeWidth="1.58" />
                    <path
                        d="M71.24,479.75c13.42,0,13.42-42,26.83-42s13.42,42,26.84,42,13.41-42,26.83-42,13.42,42,26.84,42,13.41-42,26.83-42,13.42,42,26.84,42,13.42-42,26.84-42,13.42,42,26.84,42,13.41-42,26.83-42,13.41,42,26.83,42,13.42-42,26.83-42,13.42,42,26.84,42,13.42-42,26.83-42,13.42,42,26.84,42,13.42-42,26.84-42,13.42,42,26.84,42"
                        fill="none" stroke="#30b179" strokeMiterlimit="10" strokeWidth="1.58" />
                </g>
            </g>
            <g>
                <rect x="139.68" y="76.04" width="29.6" height="6.69" fill="#fffffe" />
                <rect x="139.68" y="68.42" width="29.6" height="4.09" fill="#fffffe" />
                <rect x="139.68" y="62.11" width="29.6" height="2.96" fill="#fffffe" />
                <rect x="139.68" y="55.79" width="29.6" height="1.84" fill="#fffffe" />
            </g>
            <g>
                <rect x="20.93" y="279.67" width="6.92" height="67.88" fill="#fffffe" />
                <rect x="13.05" y="279.67" width="4.23" height="67.88" fill="#fffffe" />
                <rect x="6.53" y="279.67" width="3.06" height="67.88" fill="#fffffe" />
                <rect y="279.67" width="1.9" height="67.88" fill="#fffffe" />
            </g>
            <g id="bl-4">
                <path d="M379,444H599V326H379Z" fill="#fffffe" fillRule="evenodd" />
                <g>
                    <polyline
                        points="600 445 474 445 474 443.6 598.58 443.6 598.58 386 600 386 600 445"
                        fill="#192331" fillRule="evenodd" />
                    <polyline
                        points="600 335 598.6 335 598.6 325.31 560 325.31 560 324 600 324 600 335"
                        fill="#192331" fillRule="evenodd" />
                    <rect x="532" y="325" width="15" height="1" fill="#192331" />
                </g>
                <path d="M575,380h49V341H575Z" fill="#d7dc61" fillRule="evenodd" />
                <g>
                    <rect x="557" y="421" width="24" height="7" fill="#b6c3d7" />
                    <rect x="570" y="408" width="11" height="7" fill="#b6c3d7" />
                </g>
                <path d="M379,313H599V292H379Z" fill="#fffffe" fillRule="evenodd" />
                <path d="M600,314H540v-1.45h58.59V292.46h-50V291H600v23" fill="#192331"
                      fillRule="evenodd" />
                <g>
                    <path d="M394,303a4,4,0,1,1-4-4,4,4,0,0,1,4,4" fill="#30b179"
                          fillRule="evenodd" />
                    <path d="M408,303a4,4,0,1,1-4-4,4,4,0,0,1,4,4" fill="#30b179"
                          fillRule="evenodd" />
                    <path d="M420,303a4,4,0,1,1-4-4,4,4,0,0,1,4,4" fill="#30b179"
                          fillRule="evenodd" />
                </g>
                <g>
                    <path
                        d="M446.5,354.42a34.08,34.08,0,1,0,34.08,34.08A34.12,34.12,0,0,0,446.5,354.42Zm0,69.58A35.5,35.5,0,1,1,482,388.5,35.55,35.55,0,0,1,446.5,424Z"
                        fill="#192331" fillRule="evenodd" />
                    <g id="diagram-2">
                        <path d="M469,389a23,23,0,1,1-23-23,23,23,0,0,1,23,23" fill="#30b179"
                              fillRule="evenodd" />
                        <path d="M457,389a11,11,0,1,1-11-11,11,11,0,0,1,11,11" fill="#192331"
                              fillRule="evenodd" />
                    </g>
                    <polyline
                        points="460.13 372 459 371.14 475.36 349 490 349 490 350.44 476.07 350.44 460.13 372"
                        fill="#192331" fillRule="evenodd" />
                    <rect x="497" y="343" width="21" height="1" fill="#192331" />
                    <rect x="497" y="349" width="21" height="1" fill="#192331" />
                    <path d="M508,355h10v-1H508Z" fill="#30b179" fillRule="evenodd" />
                    <rect x="399" y="343" width="12" height="1" fill="#192331" />
                    <rect x="391" y="349" width="21" height="1" fill="#192331" />
                    <rect x="489" y="427" width="21" height="1" fill="#192331" />
                    <rect x="489" y="422" width="21" height="1" fill="#192331" />
                    <path d="M489,417h10v-1H489Z" fill="#30b179" fillRule="evenodd" />
                    <path d="M401,355h10v-1H401Z" fill="#30b179" fillRule="evenodd" />
                </g>
                <polyline
                    points="483 423 471.11 423 452 398.84 453.12 398 471.8 421.62 483 421.62 483 423"
                    fill="#192331" fillRule="evenodd" />
                <polyline
                    points="429.88 358 424.34 349.46 418 349.46 418 348 425.05 348 431 357.17 429.88 358"
                    fill="#192331" fillRule="evenodd" />
                <g id="bars-4">
                    <rect x="500" y="383" width="10" height="16" fill="#e2e8ef" />
                    <rect x="517" y="373" width="10" height="26" fill="#e2e8ef" />
                    <rect x="533" y="364" width="10" height="36" fill="#e2e8ef" />
                    <rect x="551" y="389" width="10" height="10" fill="#e2e8ef" />
                </g>
            </g>
            <path d="M288,460H554v-7H288Zm0-9H554v-4H288Zm0-7H554v-3H288Zm0-7H554v-2H288Z"
                  fill="#e4e8eb" fillRule="evenodd" />
            <g id="bl-3">
                <path d="M384,235H624V75H384Zm81,0,38.51,45L544,235H465" fill="#30b179"
                      fillRule="evenodd" />
                <g>
                    <path d="M450,110.5A15.5,15.5,0,1,1,434.5,95,15.5,15.5,0,0,1,450,110.5"
                          fill="#fffffe" fillRule="evenodd" />
                    <path d="M461,152H411c0-10.49,11.19-19,25-19s25,8.51,25,19" fill="#fffffe"
                          fillRule="evenodd" />
                </g>
                <g>
                    <g>
                        <path d="M480,120H607v-1H480Z" fill="#192331" fillRule="evenodd" />
                        <path d="M499,118.5a5.5,5.5,0,1,1-5.5-5.5,5.5,5.5,0,0,1,5.5,5.5"
                              fill="#192331" fillRule="evenodd" />
                        <path d="M550,118.5a5.5,5.5,0,1,1-5.5-5.5,5.5,5.5,0,0,1,5.5,5.5"
                              fill="#fffffe" fillRule="evenodd" />
                        <path d="M599,118.5a5.5,5.5,0,1,1-5.5-5.5,5.5,5.5,0,0,1,5.5,5.5"
                              fill="#192331" fillRule="evenodd" />
                    </g>
                    <g>
                        <rect x="492" y="97" width="1" height="11" fill="#192331" />
                        <rect x="504" y="97" width="1" height="11" fill="#192331" />
                        <rect x="517" y="97" width="1" height="11" fill="#192331" />
                        <rect x="530" y="97" width="1" height="11" fill="#192331" />
                        <path d="M543,108h1V97h-1Z" fill="#fffffe" fillRule="evenodd" />
                        <rect x="556" y="97" width="1" height="11" fill="#192331" />
                        <rect x="569" y="97" width="1" height="11" fill="#192331" />
                        <rect x="581" y="97" width="1" height="11" fill="#192331" />
                        <rect x="594" y="97" width="1" height="11" fill="#192331" />
                    </g>
                </g>
                <g id="bars-3">
                    <rect x="496" y="180" width="28" height="30" fill="#192331" />
                    <path d="M534,210h28V151H534Z" fill="#fffffe" fillRule="evenodd" />
                    <rect x="574" y="158" width="28" height="51" fill="#192331" />
                </g>
                <g>
                    <path
                        d="M457.59,216H412.41a8.32,8.32,0,0,1-8.41-8.2V176h1.41v31.8a6.92,6.92,0,0,0,7,6.82h45.18a6.92,6.92,0,0,0,7-6.82V176H466v31.8a8.32,8.32,0,0,1-8.41,8.2"
                        fill="#192331" fillRule="evenodd" />
                    <path
                        d="M466,175h-1.41a7.27,7.27,0,0,0-7-7.49H412.41a7.27,7.27,0,0,0-7,7.49H404c0-5,3.77-9,8.41-9h45.18c4.64,0,8.41,4,8.41,9"
                        fill="#fffffe" fillRule="evenodd" />
                    <path d="M416,179h37v-1H416Z" fill="#192331" fillRule="evenodd" />
                    <path d="M416,189h37v-1H416Z" fill="#fffffe" fillRule="evenodd" />
                    <rect x="437" y="200" width="16" height="1" fill="#192331" />
                </g>
                <g>
                    <path d="M599,92h49V53H599Z" fill="#192331" fillRule="evenodd" />
                    <path d="M609.62,82.56h26.69l-13.64-20-13,20ZM639,84H607l15.64-24Z"
                          fill="#fffffe" fillRule="evenodd" />
                </g>
                <path d="M624.21,83,623,82.24,631.79,72l1.21.76L624.21,83" fill="#fffffe"
                      fillRule="evenodd" />
                <path d="M394,236H384V223h1.35v11.61H394V236" fill="#192331" fillRule="evenodd" />
                <g id="splash-2">
                    <path d="M377.52,64.55l-11-14.11" fill="none" stroke="#192331"
                          strokeMiterlimit="10" strokeWidth="1.58" fillRule="evenodd"
                          strokeDasharray="18 18" strokeDashoffset="54" />
                    <path d="M390.81,61.87l2.52-10.72" fill="none" stroke="#192331"
                          strokeMiterlimit="10" strokeWidth="1.58" fillRule="evenodd"
                          strokeDasharray="18 18" strokeDashoffset="54" />
                    <path d="M373,76h-8" fill="none" stroke="#192331" strokeMiterlimit="10"
                          strokeWidth="1.58" fillRule="evenodd" strokeDasharray="18 18"
                          strokeDashoffset="54" />
                </g>
            </g>
            <g id="bl-2">
                <polygon
                    points="82.88 196.63 82.88 375.91 173.71 375.91 216.91 426.04 262.32 375.91 350.94 375.91 350.94 196.63 82.88 196.63"
                    fill="#30b179" fillRule="evenodd" />
                <rect x="103.13" y="239.42" width="70.08" height="22.03" fill="#192331" />
                <path d="M103.13,293h51.44v-22H103.13Z" fill="#fffffe" fillRule="evenodd" />
                <g id="chart-shape">
                    <path
                        d="M136.29,356.07s30.8-55,61.81-38.69,21.35-49.69,64.57-44.44,57.27,83.13,57.27,83.13H136.29"
                        fill="#192331" fillRule="evenodd" />
                    <path
                        d="M134.47,356.07c.58,0,3.25-4.2,3.67-4.69a66.81,66.81,0,0,1,10.47-10,31.15,31.15,0,0,1,18.53-6.35c5.31-.06,10,2.84,15.05,3.81,11.49,2.2,14.7-8,15.3-17.3a43.68,43.68,0,0,1,4.68-17.19c3.69-7,10.12-11.81,18.19-12.16,5.8-.25,11.51,1.46,16.95,3.51,11.11,4.18,22.4,9.31,34.55,7.27,11.63-2,18.91-10.56,21.29-21.89,7.14-34,26.79-19.69,26.79-6v80.93H134.47"
                        fill="#fffffe" fillRule="evenodd" />
                </g>
                <g id="bars-2">
                    <polyline
                        points="292.11 356.07 286.62 356.06 286.78 309.26 292.27 309.28 292.11 356.07"
                        fill="#b6c3d7" fillRule="evenodd" />
                    <rect x="258.45" y="328.96" width="5.49" height="27.11" fill="#b6c3d7" />
                    <rect x="230.29" y="318.31" width="5.5" height="37.76" fill="#b6c3d7" />
                    <rect x="202.12" y="339.77" width="5.5" height="16.3" fill="#b6c3d7" />
                </g>
                <path id="chart" d="M148.38,318.34l34.19-36.49L233,270.44l36.5-23.81" fill="none"
                      stroke="#192331" strokeMiterlimit="10" strokeWidth="1.58"
                      fillRule="evenodd" />
                <line x1="233.04" y1="265.13" x2="233.04" y2="275.16" fill="none" stroke="#192331"
                      strokeMiterlimit="10" strokeWidth="1.58" />
                <line x1="182.57" y1="277.2" x2="182.57" y2="287.23" fill="none" stroke="#192331"
                      strokeMiterlimit="10" strokeWidth="1.58" />
                <g id="splash-1">
                    <path d="M74.87,374.21l-12.46,1.23" fill="none" stroke="#192331"
                          strokeMiterlimit="10" strokeWidth="1.58" fillRule="evenodd"
                          strokeDasharray="13 13" strokeDashoffset="39" />
                    <path d="M77.31,386.2l-8.51,8.6" fill="none" stroke="#192331"
                          strokeMiterlimit="10" strokeWidth="1.58" fillRule="evenodd"
                          strokeDasharray="13 13" strokeDashoffset="39" />
                    <path d="M91.26,384.33,93.78,397" fill="none" stroke="#192331"
                          strokeMiterlimit="10" strokeWidth="1.58" fillRule="evenodd"
                          strokeDasharray="13 13" strokeDashoffset="39" />
                </g>
            </g>
            <g id="bl-1">
                <path d="M134.47,250.27H381.32V118H134.47Z" fill="#fffffe" fillRule="evenodd" />
                <path d="M243.65,118.74H331v-1.58H243.65Z" fill="#192331" fillRule="evenodd" />
                <rect x="173.08" y="219.33" width="169.63" height="1.59" fill="#192331" />
                <g id="bars-1">
                    <rect x="191.59" y="164.91" width="1.58" height="42.52" fill="#192331" />
                    <path d="M213.43,207.43H215V176.65h-1.58Z" fill="#30b179" fillRule="evenodd" />
                    <rect x="278.94" y="188.39" width="1.58" height="19.04" fill="#192331" />
                    <rect x="235.27" y="153.81" width="1.58" height="53.63" fill="#192331" />
                    <rect x="257.1" y="141.11" width="1.58" height="66.32" fill="#192331" />
                    <path d="M300.78,207.43h1.58v-39h-1.58Z" fill="#30b179" fillRule="evenodd" />
                    <path d="M322.61,207.43h1.59V154.12h-1.59Z" fill="#192331" fillRule="evenodd" />
                </g>
                <polyline
                    points="364.24 251.06 364.22 249.47 380.37 249.32 380.37 235.99 381.95 235.99 381.95 250.89 364.24 251.06"
                    fill="#192331" fillRule="evenodd" />
                <g>
                    <path d="M340.81,142.7h54.12V99.23H340.81Z" fill="#d7dc61" fillRule="evenodd" />
                    <g id="diagram">
                        <path d="M379.57,121a11.7,11.7,0,1,1-11.7-11.69" fill="none" stroke="#000"
                              strokeMiterlimit="10" strokeWidth="1.58" fillRule="evenodd" />
                        <path d="M367.87,109.27A11.69,11.69,0,0,1,379.57,121" fill="none"
                              stroke="#fff" strokeMiterlimit="10" strokeWidth="1.6"
                              fillRule="evenodd" />
                    </g>
                    <path d="M371.83,120.81a4.12,4.12,0,1,1-4.12-4.13,4.13,4.13,0,0,1,4.12,4.13"
                          fill="#fffffe" fillRule="evenodd" />
                </g>
                <rect x="154.57" y="132.7" width="27.69" height="6.35" fill="#e4e8eb" />
                <rect x="201.24" y="132.86" width="12.66" height="6.35" fill="#e4e8eb" />
            </g>
        </svg>
    );
};

